import { useAccountSettingsQuery } from '~/generated/graphql';

import { useUpdateAccountDetails } from './useUpdateAccountDetails';
import { useUpdateAccountSettings } from './useUpdateAccountSettings';
import { useUpdateAPIVersion } from './useUpdateAPIVersion';
import { useUpdateIpRanges } from './useUpdateIpRanges';
import { useUpdateSuppressionSettings } from './useUpdateSuppressionSettings';

export function useAccountSettings() {
  const { data, loading, refetch } = useAccountSettingsQuery();
  const { updateAccountSettings } = useUpdateAccountSettings();
  const { updateAccountDetails } = useUpdateAccountDetails();
  const { updateAPIVersion } = useUpdateAPIVersion();
  const { updateSuppressionSettings } = useUpdateSuppressionSettings();
  const { updateIpRanges, updateIpRangesLoading } = useUpdateIpRanges();

  return {
    loading,
    refetch,
    name: data?.account?.name ?? '',
    publishableToken: data?.account?.publishableToken ?? '',
    secretToken: data?.account?.secretToken ?? '',
    webhookUrl: data?.account?.webhookUrl ?? '',
    remoteAllowedReferrers: data?.account?.remoteAllowedReferrers ?? [],
    allowedIpRanges: data?.account?.allowedIpRanges ?? [],
    apiVersions: data?.account?.apiVersions,
    suppressionSettings: data?.account?.suppressionSettings,
    mfaEnforced: data?.account?.mfaEnforced ?? false,
    updateAccountSettings,
    updateAccountDetails,
    updateAPIVersion,
    updateSuppressionSettings,
    updateIpRanges,
    updateIpRangesLoading,
  };
}
